export default __webpack_public_path__ + "static/media/home.7a1e5ce7.png";